import React from 'react';
import { px } from 'csx';
import { style } from 'typestyle';
import { rebrand } from '../../../theme/color';
import { minBodyHeight } from '../config';
import { heading2 } from '../utilities/font';
import { ComponentProps, deps, inject, observer } from '../../../lib/component';
import { AnalyticsController } from '../../../modules/analytics/controller';

import { SIGN_UP_ROUTE } from '../../../constants';
import { GoogleButton } from '../../user/google-button';
import { Link } from '../atoms/Link';
import { spacing } from '../../../theme/spacing';
import { Accreditations } from '../molecules/Accreditations';
import { LoginContent } from '../templates/LoginContent';

const styles = {
  content: style({
    minHeight: minBodyHeight,
  }),
  panelHeading: style(heading2, {
    marginTop: spacing.XLARGE,
  }),
  panelText: style({
    margin: `${spacing.DEFAULT} 0 0`,
    fontSize: px(20),
  }),
  googleButton: style({
    height: px(48),
    marginTop: px(32),
  }),
  logInPrompt: style({
    color: rebrand.contrast[40].toString(),
    marginTop: spacing.DEFAULT,
    marginBottom: 0,
    fontSize: px(12),
    $nest: {
      '& a': {
        textDecoration: 'underline',
        color: rebrand.contrast[50].toString(),
      },
    },
  }),
};

const sendClickLoginEvent = (analytics: AnalyticsController) =>
  analytics.sendMixpanel('User clicks sign up prompt', { path: '/log-in' });

export const LogIn = inject(deps)(
  observer(({ model: { auth: { youtubeLoginURL } }, controller: { analytics } }: ComponentProps) => (
    <LoginContent className={styles.content}>
      <Accreditations />

      <h1 data-test-login-h1 className={styles.panelHeading}>
        Welcome back
      </h1>

      <p className={styles.panelText} data-test-login-h2>
        Log in to your Lickd Account
      </p>

      <GoogleButton
        className={styles.googleButton}
        href={youtubeLoginURL}
        text="Sign in with Google"
        data-test-login-button-google
      />

      <p className={styles.logInPrompt}>
        Don&apos;t have an account?{' '}
        <Link href={SIGN_UP_ROUTE} onClick={() => sendClickLoginEvent(analytics)}>
          Sign up
        </Link>
      </p>
    </LoginContent>
  ))
);
